import React from 'react';
import CurrencyFormat, { CurrencyFormatFunc } from '../../Formatters/CurrencyFormat';

export default function PermCoverageAmounts(isJuvi, sliderList) {
  const start = 10000;
  const end = isJuvi ? 75000 : 150000;
  const increment = 5000;
  var amounts = [];

  for (var i = start; i <= end; i += increment) {
    if (i === start) {
      amounts.push({ label: sliderList? <CurrencyFormat number={i} whole shortK={sliderList} /> : CurrencyFormatFunc(i, true), value: i });
    } else if (i === end) {
      amounts.push({ label: sliderList? <CurrencyFormat number={i} whole shortK={sliderList} />: CurrencyFormatFunc(i, true), value: i });
    } else {
      amounts.push({ label: sliderList? '' : CurrencyFormatFunc(i, true), value: i });
    }
  }

  return amounts;
}



// WEBPACK FOOTER //
// ./src/components/Helpers/Lists/CoverageAmounts/PermCoverageAmounts.js